import React from 'react';
import { useSelector } from 'react-redux';
import { getUserName } from '@redux/selectors/UserSelector';

import Button from 'react-bootstrap/Button';
import prospectsIcon from '@images/logos/vendor/prospects_white_tr.svg';
import GAEventTracking from '@components/tracking/GAEventTracking';

const ProspectsWidget = () => {
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  return (
    <div className="panel-content text-center rounded" style={{ backgroundColor: '#143f62', minHeight: '231px' }}>
      <img alt="prospects-icon" src={prospectsIcon} className="img-fluid mb-3" style={{ height: '40px' }} />
      <p className="mb-4" style={{ color: 'var(--darkText-2)' }}>
        <strong>Prospects CRM™ </strong>
        is the ONLY CRM that seamlessly integrates with your MLS listing and client data, creating all kinds of timesaving automations and premium engagement tools.
      </p>
      <Button
        onClick={() => {
          window.open('https://ca.prospects.com/prospects/logon.do?locale=en', '_blank');
          gaEventTracker('Opened Prospects', `${username}`);
        }}
        variant="primary"
      >
        <i className="far fa-external-link mr-2" />
        Prospects CRM™
      </Button>
    </div>
  );
};

export default ProspectsWidget;
